import { connect } from "react-redux";

import {
  searchOpportunitySharedAssets,
} from "src/legacy/redux/actions/search";
import { fetchCRMEnabledIntegration } from "src/legacy/redux/actions/integrations";
import { searchMsDynamicsOpportunityRecommendedAssets } from "src/legacy/redux/actions/search";

import MsDynamicsOpportunityRecommendedAssetsView from "./view";

const mapStateToProps = (state, ownProps) => {
  const opportunityId = window.location.pathname.split('/')[4];

  return {
    id: opportunityId,
    recommended: state.legacyRootReducer.search.opportunityRecommendedContents,
    shared: state.legacyRootReducer.search.opportunitySharedContents,
    integration: state.legacyRootReducer.settings.integrations.activated.crmIntegration,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    searchMsDynamicsOpportunityRecommendedAssets: (opportunityId) => {
      dispatch(searchMsDynamicsOpportunityRecommendedAssets(opportunityId));
    },
    searchOpportunitySharedAssets: (opportunityId) => {
      dispatch(searchOpportunitySharedAssets(opportunityId));
    },
    fetchCRMEnabledIntegration: () => {
      dispatch(fetchCRMEnabledIntegration());
    },
  };
};

const MsDynamicsOpportunityRecommendedAssetsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(MsDynamicsOpportunityRecommendedAssetsView);

export default MsDynamicsOpportunityRecommendedAssetsContainer;